module.exports = __webpack_public_path__ + "static/media/fabio_pinto.b5416a55.jpg";